define('helperEntity-isContentPage',[],function() {
    'use strict';

    var isContentPage = function(entity) {
        return (entity && entity.typeId === 10) ? true : false;
    };

    return isContentPage;
});

